import { useEffect, useRef } from "react";
import { useLeadModal } from "../../context/LeadModalContext";

// Opens the consultation modal once, ~18s after landing (exit-intent style timing).
export function CtaPopup() {
	const { openLeadModal } = useLeadModal();
	const fired = useRef(false);

	useEffect(() => {
		if (sessionStorage.getItem("sx-popup-shown")) return;
		const t = setTimeout(() => {
			if (fired.current) return;
			fired.current = true;
			sessionStorage.setItem("sx-popup-shown", "1");
			openLeadModal({ sourcePage: "CTA Popup" });
		}, 18000);
		return () => clearTimeout(t);
	}, [openLeadModal]);

	return null;
}
